module.exports = __webpack_public_path__ + "img/tg_03 (6).12c30e13.jpg";